import type { ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicator from '@mui/icons-material/DragIndicator';
import { DashboardDragHandle, DashboardSortableRowRoot } from './dashboardControls.styles';

interface DashboardSortableRowProps {
  action?: ReactNode;
  children: ReactNode;
  disabled?: boolean;
  id: string;
}

// The repo has this row twice already (FirmSummaryWorkspace's sort/filter lists and
// EditColumnsPanel), but both copies are file-local and neither is exported, so this is a third —
// scoped to the dialog rather than reaching across pages for a 40-line component.
const DashboardSortableRow = ({ action, children, disabled = false, id }: DashboardSortableRowProps) => {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id,
    disabled,
  });

  return (
    <DashboardSortableRowRoot
      ref={setNodeRef}
      isDragging={isDragging}
      style={{ transform: CSS.Transform.toString(transform), transition }}>
      <DashboardDragHandle {...(disabled ? { 'aria-disabled': true } : { ...attributes, ...listeners })}>
        <DragIndicator fontSize="small" />
      </DashboardDragHandle>
      {children}
      {action}
    </DashboardSortableRowRoot>
  );
};

export default DashboardSortableRow;
